import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import axios from 'axios'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = localStorage.getItem('token') !== null

  if (requiresAuth && !isAuthenticated) {
    next('/')
  } else {
    next()
  }

  if (to.path == '/admin') {
    let token = localStorage.getItem('token')
    axios.get(`${process.env.VUE_APP_AXIOS}/user`, {
      headers: {
        token: token
      }
    }).then(res => {
      console.log(res.data)
      if (res.data.user.role == 'admin') {
        next()
      } else {
        next('/')
      }
    })
  }

})

export default router
